import { RadarChart } from '@mui/x-charts/RadarChart';

export default function RadarGraphic({ radar, state, toggleCategory }) {
    const metrics = radar.metrics
    const max = radar.max

    const series = [metrics.reduce(
        (obj, s) => {
            obj.data.push(state[s] || 0)
            return obj
        }, {fillArea: true, data: []})
    ]

    function handlerClick(e) {
        let target = e.target

        if (target.tagName == "tspan") {
            let value = toggleCategory(target.innerHTML)
            if (value) {
                target.classList.remove("disabled")
            } else {
                target.classList.add("disabled")
            }
        }
    }

    return (
            <RadarChart
                onClick={handlerClick}
                series={ series }
                radar={ { metrics: metrics, max: max } }
                height={300}
                alt="graph-radar"
            />
        )
}